// extracted by css-extract-rspack-plugin
export default {"drop":"drop--fUQOhnZBiyA61Xfj"};